module.exports = __webpack_public_path__ + "img/数据中心.16f434f1.png";